const systemManagementTestData = {
  commonCodeManagement: [
    {
      no: 1,
      classificationCode: "치료제 카테고리",
      codeName: "동기면담",
      codeId: "TCATOO1",
      state: "사용",
      registrantName: "홍길동",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      no: 2,
      classificationCode: "치료제 카테고리",
      codeName: "질환교육",
      codeId: "TCATOO2",
      state: "미사용",
      registrantName: "강길동",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      no: 3,
      classificationCode: "치료제 카테고리",
      codeName: "기능분석",
      codeId: "TCATOO3",
      state: "사용",
      registrantName: "김길동",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      no: 4,
      classificationCode: "치료제 카테고리",
      codeName: "행동활성화",
      codeId: "TCATOO4",
      state: "사용",
      registrantName: "박길동",
      updateTime: "2021-10-12 11:00:00",
    },
  ],
  permissionManagement: [
    {
      no: 1,
      roleName: "시스템 관리자",
      roleCode: "ROLE_ADMIN",
      description: "Super user",
      state: "사용",
    },
    {
      no: 2,
      roleName: "서비스 운영자",
      roleCode: "ROLE_OPT",
      description: "서비스운영을 지원하는 전산인력",
      state: "사용",
    },
    {
      no: 3,
      roleName: "코디네이터",
      roleCode: "ROLE_COORD",
      description: "코디네이터",
      state: "사용",
    },
    {
      no: 4,
      roleName: "의사",
      roleCode: "ROLE_DOC",
      description: "의사",
      state: "사용",
    },
    {
      no: 5,
      roleName: "임상심리사",
      roleCode: "ROLE_TEST",
      description: "임상심리사",
      state: "미사용",
    },
  ],
  functionManagement: [
    {
      no: 1,
      upperFunction: "시스템관리",
      functionName: "메뉴관리",
      functionId: "TCATOO1",
      state: "사용",
      registrantName: "홍길동",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      no: 2,
      upperFunction: "시스템관리",
      functionName: "권한관리",
      functionId: "TCATOO2",
      state: "미사용",
      registrantName: "강길동",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      no: 3,
      upperFunction: "시스템관리",
      functionName: "공통 코드관리",
      functionId: "TCATOO3",
      state: "사용",
      registrantName: "김길동",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      no: 4,
      upperFunction: "시스템관리",
      functionName: "사용자등록",
      functionId: "TCATOO4",
      state: "사용",
      registrantName: "시스템관리",
      updateTime: "2021-10-12 11:00:00",
    },
  ],
  userManagement: [
    {
      index: 1,
      userId: "hong",
      name: "홍길동",
      phoneNum: "010-1234-5678",
      gender: "남",
      email: "aaaa@gmail.com",
      agency: "한림대학교",
      department: "신경과",
      permission: "의사",
      regNm: "홍길동",
      useYn: "사용",
      regDttm: "2021-10-12- 11:00:00",
    },
    {
      index: 2,
      userId: "kang",
      name: "강길동",
      phoneNum: "010-1234-5678",
      gender: "남",
      email: "bbbb@gmail.com",
      agency: "한림대학교",
      department: "정신겅강의학과",
      permission: "의사",
      regNm: "홍길동",
      useYn: "미사용",
      regDttm: "2021-10-12- 11:00:00",
    },
    {
      index: 3,
      userId: "kim",
      name: "김길동",
      phoneNum: "010-1234-5678",
      gender: "남",
      email: "cccc@gmail.com",
      agency: "유비플러스",
      department: "개발팀",
      permission: "시스템관리자",
      regNm: "홍길동",
      useYn: "사용",
      regDttm: "2021-10-12- 11:00:00",
    },
    {
      index: 4,
      userId: "choi",
      name: "최길동",
      phoneNum: "010-1234-5678",
      gender: "남",
      email: "ddddd@gmail.com",
      agency: "유비플러스",
      department: "운영팀",
      permission: "시스템운영자",
      regNm: "홍길동",
      useYn: "사용",
      regDttm: "2021-10-12- 11:00:00",
    },
  ],
  agencyManagement: [
    {
      index: 1,
      agency: "한림대학교병원",
      reptativeName: "홍길동",
      regNum: "010-1234-5678",
      reptativeNum: "010-1234-5678",
      manager: "",
      email: "ddddd@gmail.com",
      faxNum: "010-1234-5678",
      regNm: "홍길동",
      useYn: "사용",
      regDttm: "2021-10-12- 11:00:00",
    },
    {
      index: 2,
      agency: "유비플러스",
      reptativeName: "최길동",
      regNum: "010-1234-5678",
      reptativeNum: "010-1234-5678",
      manager: "",
      email: "aaaa@gmail.com",
      faxNum: "010-1234-5678",
      regNm: "홍길동",
      useYn: "사용",
      regDttm: "2021-10-12- 11:00:00",
    },
    {
      index: 3,
      agency: "테스트기관",
      reptativeName: "김길동",
      regNum: "010-1234-5678",
      reptativeNum: "010-1234-5678",
      manager: "",
      email: "cccc@gmail.com",
      faxNum: "010-1234-5678",
      regNm: "홍길동",
      useYn: "사용",
      regDttm: "2021-10-12- 11:00:00",
    },
    {
      index: 4,
      agency: "개발기관",
      reptativeName: "홍길동",
      regNum: "010-1234-5678",
      reptativeNum: "010-1234-5678",
      manager: "",
      email: "ffff@gmail.com",
      faxNum: "010-1234-5678",
      regNm: "홍길동",
      useYn: "사용",
      regDttm: "2021-10-12- 11:00:00",
    },
  ],
  adminMenuManagement: [
    {
      menuHighNm: "",
      menuHighId: "",
      menuNm: "파일 관리",
      menuId: "MENU0101",
      basePath: "admin",
      link: "/admin/fileManagement",
      funcId: "FUNC010101",
      funcNm: "알코올중독 치료 환자 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "",
      menuHighId: "",
      menuNm: "가능 관리",
      menuId: "MENU0101",
      basePath: "admin",
      link: "/admin/funcManagement",
      funcId: "FUNC010101",
      funcNm: "알코올중독 치료 환자 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
  ],
  menuManagement: [
    {
      menuHighNm: "",
      menuHighId: "",
      menuNm: "대시보드",
      menuId: "MENU0100",
      basePath: "dashboard",
      link: "",
      funcId: "FUNC010100",
      funcNm: "대시보드 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "대시보드",
      menuHighId: "MENU0100",
      menuNm: "알코올 중독 치료",
      menuId: "MENU0101",
      basePath: "dashboard",
      link: "/dashboard/astop",
      funcId: "FUNC010101",
      funcNm: "알코올중독 치료 환자 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "대시보드",
      menuHighId: "MENU0100",
      menuNm: "인지장애 치료",
      menuId: "MENU0102",
      basePath: "dashboard",
      link: "/dashboard/mstrong",
      funcId: "FUNC010102",
      funcNm: "인지장애 치료 환자 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "",
      menuHighId: "",
      menuNm: "환자 관리",
      menuId: "MENU0200",
      basePath: "patientCare",
      link: "",
      funcId: "FUNC020100",
      funcNm: "환자 관리",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "환자 관리",
      menuHighId: "MENU0200",
      menuNm: "환자 조회",
      menuId: "MENU0201",
      basePath: "patientCare",
      link: "/patientCare/patientInquiry",
      funcId: "FUNC020101",
      funcNm: "환자 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "환자 관리",
      menuHighId: "MENU0200",
      menuNm: "처방전 템플릿",
      menuId: "MENU0202",
      basePath: "patientCare",
      link: "/patientCare/prescriptionTemplate",
      funcId: "FUNC020102",
      funcNm: "처방전 템플릿 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "",
      menuHighId: "",
      menuNm: "치료제 관리",
      menuId: "MENU0300",
      basePath: "remedyManagement",
      link: "",
      funcId: "FUNC030100",
      funcNm: "치료제 관리",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "치료제 관리",
      menuHighId: "MENU0300",
      menuNm: "치료제 조회",
      menuId: "MENU0301",
      basePath: "remedyManagement",
      link: "/remedyManagement/remedyInquiry",
      funcId: "FUNC030101",
      funcNm: "치료제 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    /*{
      menuHighNm: "치료제 관리",
      menuHighId: "MENU0300",
      menuNm: "카테고리",
      menuId: "MENU0302",
      basePath: "remedyManagement",
      link: "/remedyManagement/remedyCategory",
      funcId: "FUNC030102",
      funcNm: "카테고리 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },*/
    {
      menuHighNm: "",
      menuHighId: "",
      menuNm: "치료약 관리",
      menuId: "MENU0400",
      basePath: "medicineManagement",
      link: "",
      funcId: "FUNC040100",
      funcNm: "치료약 관리",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "치료약 관리",
      menuHighId: "MENU0400",
      menuNm: "치료약 조회",
      menuId: "MENU0401",
      basePath: "medicineManagement",
      link: "/medicineManagement/medicineInquiry",
      funcId: "FUNC040101",
      funcNm: "치료약 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    /*{
      menuHighNm: "치료약 관리",
      menuHighId: "MENU0400",
      menuNm: "카테고리",
      menuId: "MENU0402",
      basePath: "medicineManagement",
      link: "/medicineManagement/medicineCategory",
      funcId: "FUNC040102",
      funcNm: "카테고리 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },*/
    {
      menuHighNm: "",
      menuHighId: "",
      menuNm: "시스템 관리",
      menuId: "MENU0500",
      basePath: "systemManagement",
      link: "",
      funcId: "FUNC050100",
      funcNm: "시스템 관리",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "시스템 관리",
      menuHighId: "MENU0500",
      menuNm: "공통코드 관리",
      menuId: "MENU0501",
      basePath: "systemManagement",
      link: "/systemManagement/commonCodeManagement",
      funcId: "FUNC050101",
      funcNm: "공통코드 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "시스템 관리",
      menuHighId: "MENU0500",
      menuNm: "권한 관리",
      menuId: "MENU0502",
      basePath: "systemManagement",
      link: "/systemManagement/permissionManagement",
      funcId: "FUNC050102",
      funcNm: "권한 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "시스템 관리",
      menuHighId: "MENU0500",
      menuNm: "기능 관리",
      menuId: "MENU0503",
      basePath: "systemManagement",
      link: "/systemManagement/functionManagement",
      funcId: "FUNC050103",
      funcNm: "기능 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "시스템 관리",
      menuHighId: "MENU0500",
      menuNm: "메뉴 관리",
      menuId: "MENU0504",
      basePath: "systemManagement",
      link: "/systemManagement/menuManagement",
      funcId: "FUNC050104",
      funcNm: "메뉴 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "시스템 관리",
      menuHighId: "MENU0500",
      menuNm: "사용자 관리",
      menuId: "MENU0505",
      basePath: "systemManagement",
      link: "/systemManagement/userManagement",
      funcId: "FUNC050105",
      funcNm: "사용자 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "시스템 관리",
      menuHighId: "MENU0500",
      menuNm: "기관 관리",
      menuId: "MENU0506",
      basePath: "systemManagement",
      link: "/systemManagement/agencyManagement",
      funcId: "FUNC050106",
      funcNm: "기관 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
    {
      menuHighNm: "시스템 관리",
      menuHighId: "MENU0500",
      menuNm: "앱 로그 조회",
      menuId: "MENU0507",
      basePath: "systemManagement",
      link: "/systemManagement/appLogInquiry",
      funcId: "FUNC050107",
      funcNm: "앱 로그 조회",
      useYn: "Y",
      regNm: "홍길동",
      updDttm: "2021-10-12- 11:00:00",
    },
  ],
};

export default systemManagementTestData;
